module.exports = __webpack_public_path__ + "img/secretariat.33361ec0.jpg";